import type { Patient, Reference } from '@medplum/fhirtypes'
import type { SeenMedplumClient } from '#src/client.ts'
import { IDT } from '#src/models/care-teams/idt.ts'
import { Participant } from '#src/models/patients/participant.ts'
import { ExtendedPractitioner } from '#src/models/practitioner.ts'
import { Role } from '#src/roles.ts'

export async function getParticipantPCP({
  medplum,
  participant,
}: {
  medplum: SeenMedplumClient
  participant: Reference<Patient> | Participant
}): Promise<ExtendedPractitioner | undefined> {
  const participantRef =
    participant instanceof Participant ? participant.reference : participant
  if (!participantRef) {
    return undefined
  }
  const idt = await medplum.searchOneResourceClass(
    IDT,
    IDT.byParticipant(participantRef)
  )
  if (!idt) {
    return undefined
  }
  const pcpRef = idt.getMemberByRole(Role.PCP)?.practitioner
  if (!pcpRef) {
    return undefined
  }
  return medplum.readResourceClass(ExtendedPractitioner, pcpRef)
}
